import React, { useCallback, useEffect, useState } from 'react'
import { Button } from 'components/common/Buttons/Button'
import Input from 'components/common/Input/Input'
import styles from './SearchFilter.module.scss'
import { TagInput } from 'components/common/Input/TagInput'
import { getRootDomain } from 'utils/parseUrl'

interface Props {
  placeholder?: string
  isLoading?: boolean
  searchText?: string
  value?: string
}

interface SingleProps extends Props {
  type?: 'single'
  onChange: (value: string) => void
}

interface MultipleProps extends Props {
  type?: 'multiple'
  onChange: (value: string[]) => void
}

const SearchFilter: React.FC<SingleProps | MultipleProps> = ({
  type = 'single',
  placeholder = 'Ex. google.com',
  onChange,
  isLoading = false,
  searchText = 'Search',
  value = '',
}) => {
  const [inputValue, setInputValue] = useState('')
  const [tags, setTags] = useState<string[]>([])

  const handleFilter = useCallback(() => {
    onChange(
      type === 'single'
        ? getRootDomain(inputValue)?.trim()?.toLowerCase()
        : (tags.map((tag) => getRootDomain(tag)?.trim()?.toLowerCase()) as any)
    )
    setTags([])
  }, [onChange, inputValue, tags, type])

  React.useEffect(() => {
    setInputValue(value)
  }, [value])
  
  return (
    <div className={styles.wrapper}>
      {type === 'single' ? (
        <Input
          placeholder={placeholder}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          isFormik={false}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleFilter()
            }
          }}
        />
      ) : (
        <TagInput placeholder={placeholder} tags={tags} onChange={setTags} />
      )}
      <Button
        size="sm"
        className={styles.searchButton}
        onClick={handleFilter}
        loading={isLoading}
        disabled={isLoading}
      >
        {searchText}
      </Button>
    </div>
  )
}

export default SearchFilter
